import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import styles from './FloatingActionButton.module.scss';

interface FloatingActionButtonProps {
  onClick: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ onClick }) => {
  return (
    <motion.button
      className={styles.fab}
      onClick={onClick}
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      whileHover={{ 
        scale: 1.1,
        boxShadow: '0 20px 40px rgba(0, 153, 255, 0.4)'
      }}
      whileTap={{ scale: 0.95 }}
      transition={{ 
        type: "spring", 
        stiffness: 300, 
        damping: 20 
      }}
    >
      <motion.div
        animate={{ rotate: 0 }}
        whileHover={{ rotate: 90 }}
        transition={{ duration: 0.2 }}
      >
        <Plus size={24} />
      </motion.div>
      <span className={styles.tooltip}>Add Report</span>
    </motion.button>
  );
};

export default FloatingActionButton;
